import general from './general'
import support from './support'

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [general, support],
}

export default menuItems
